import React, { useEffect, useState, FC } from 'react';
import axios from './axios';
import Main from './Main';
import Footer from './Components/Shared/Footer/Footer';
import Header from './Components/Shared/Header/Header';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UserDetailsContext from './Context/userDetails.context';
import { AuthService } from './Auth/AuthService';
import { RouteComponentProps, withRouter } from 'react-router';
import { User } from 'oidc-client';

const App: FC<RouteComponentProps> = ({ history, location }) => {
  const [version, setVersion] = useState('');
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    axios.get(`Info/version`).then(response => {
      setVersion(response.data);
    });
    AuthService.userManager.events.addUserLoaded((user: any) => {
      setUser(user);
    });
    AuthService.userManager.events.addUserSignedOut(() => {
      AuthService.redirectToAuthority();
    });

    AuthService.getUser().then((userFromStorage: User | null) => {
      if (!userFromStorage) return;
      setUser(userFromStorage);
    });
  }, []);

  useEffect(() => {
    document.title = 'Welcome';
    if (location.pathname.includes('/annotation-manager')) {
      document.title = 'Annotation Module';
    } else if (location.pathname.includes('/stitching-tool')) {
      document.title = 'Stitching Tool';
    } else if (location.pathname.includes('/maintenance-triggers')) {
      document.title = 'Maintenance triggers';
    } else {
      document.title = 'Welcome';
    }
  }, [history, location]);

  return (
    <React.Fragment>
      <UserDetailsContext.Provider value={{ user: user }}>
        <Header />
        {version !== '' && <Main />}
        <Footer version={version} />
        <ToastContainer />
      </UserDetailsContext.Provider>
    </React.Fragment>
  );
};

export default withRouter(App);
